import config from './config'
import quicktabs from './quicktabs'
import quicktabsHeader from './quicktabsHeader'
import viewOneColumn from './viewOneColumn'
import cspGetForm from './cspGetForm'
import isIE from './isIE'
import mobileCol from './mobileCol'
import jquery from './lib/jquery'
import vue from './lib/vue'
import elementUi from './lib/element-ui'
import smartcaptcha from './lib/smartcaptcha'
import lightbox from './lightbox'
import collapsetext from './collapsetext'
import embedBuyForm from './embedBuyForm'
import cspFastButton from './cspFastButton'
import purchaseForm from './purchaseForm'
import cpKeyTestServiceForm from './cpKeyTestServiceForm'
import chromiumGostDownload from './chromiumGost'
import user from './user'
// import search from './search'
import { loadScript } from './loadScript'
import { loadCSS } from './loadCSS'
import { waitModuleReady } from './waitModuleReady'
import { gosttls } from './gosttls'
import { createUUID, throttle, debounce } from './lib/cpAdd-ons'

import adminDrupal6Scripts from './lib/adminDrupal6Scripts'

/* window.addEventListener('load', function () {
  alert('Hello!')
}) */
const cpSite = {
  config, // Конфиг в отдельном модуле, т.к. иначе другие модули не смогут получать данные конфига при инициализации своего state
  // Стандартный интерфейс {activate(), state:{}, depend:[]}
  module: {
    // Простые скрипты
    quicktabs,
    quicktabsHeader,
    viewOneColumn,

    // Скрипты с дозагрузкой
    cspGetForm, // Форма загрузки CSP с заполнением персональных данных
    isIE,
    mobileCol,
    collapsetext,
    embedBuyForm, // Кнопка купить с дополнительной формой подходящих продуктов
    cspFastButton, // Кнопка мгновенной загрузки для авторизованных пользователей (требует публикации данных из Drupal)
    chromiumGostDownload, // Кнопка мгновенной загрузки для авторизованных пользователей (требует публикации данных из Drupal)
    purchaseForm,
    cpKeyTestServiceForm,
    // search, // Кнопка мгновенной загрузки для авторизованных пользователей (требует публикации данных из Drupal)

    // Библиотеки с дозагрузкой
    jquery,
    vue,
    elementUi, // https://element.eleme.io/#/en-US/component/layout
    smartcaptcha, // https://cloud.yandex.ru/docs/smartcaptcha/concepts/invisible-captcha
    lightbox, // https://dimsemenov.com/plugins/magnific-popup/documentation.html
    adminDrupal6Scripts,
    user
  },
  // Внутренние модули
  plugin: {
    loadScript, // Синхронная вставка новых скриптов. loadScript(url) - <script src> в head html,
    loadCSS, // Загрузка CSS в конец body
    waitModuleReady, // Интервальный опрос готовности. При наступлении критерия готовности срабатывание callback
    gosttls, // Проверка на ГОСТ TLS
    createUUID, // Создание уникального UUID
    throttle, // Ограничить выполнение не чаще промежутка (множественные нажатия)
    debounce // Задержка выполнения до наличия промежутка (валидация форм)
  },
  // На стадии до загрузки DOM
  onstart: function () {
    if (config.DEVMODE) {
      console.log('integrate:', config.integrate)
    }
    // integrate
    cpSite.config.integrate.forEach(el => { cpSite.module[el]?.integrate() })
  },
  // На стадии после загрузки DOM
  onload: function () {
    // activate
    cpSite.config.autorun.forEach(el => { cpSite.module[el]?.activate() })
  }
}

export default cpSite
